import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidatePortfolioOnForbidden } from "web_myplann/Api/Portfolio/invalidatePortfolioOnForbidden";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientPortfolioLifeInsuranceEditRequestDTO,
	type PortfolioDetailResponseDTO,
	patchPortfolioLifeInsuranceIdV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePatchPortfolioLifeInsuranceMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		PortfolioDetailResponseDTO,
		Error,
		Partial<ClientPortfolioLifeInsuranceEditRequestDTO>
	>({
		mutationFn: processResponse((requestContract) =>
			patchPortfolioLifeInsuranceIdV2(requestContract, id),
		),
		onError: (error) => invalidatePortfolioOnForbidden(queryClient, error),
		onSuccess: (data) => {
			queryClient.invalidateQueries({
				queryKey: PortfolioKeys.portfolioList(),
			});
			queryClient.setQueryData(PortfolioKeys.portfolioDetail(id), data);
		},
	});
};
